import { MONTHS_IN_YEAR } from '../../constants/common';

/** Default loan term of 50 years (600 months) is assumed for the representative example
 * and effective interest rate calculations.
 */
export const LOAN_PERIOD_YEARS = 50;

export const LOAN_PERIOD_MONTHS = LOAN_PERIOD_YEARS * MONTHS_IN_YEAR;
